import { createSlice } from "@reduxjs/toolkit";

export const INITIAL_STATE = {
  data: [],
  isLoading: false,
  isLoadingMore: false,
  isSubmitting: false,
};

const contractsHomeSlice = createSlice({
  name: "home",
  initialState: INITIAL_STATE,
  reducers: {
    setData(state, { payload }) {
      state.data = payload || [];
    },
    setIsLoading(state, { payload: isLoading = false }) {
      state.isLoading = isLoading;
    },
    setIsLoadingMore(state, { payload: isLoadingMore = false }) {
      state.isLoadingMore = isLoadingMore;
    },
    setIsSubmitting(state, { payload: isSubmitting = false }) {
      state.isSubmitting = isSubmitting;
    },
    removeById(state, { payload }) {
      state.data = state.data.filter(({ id }) => id !== payload);
    },
  },
});

export const { setData, setIsLoading, setIsLoadingMore, setIsSubmitting, removeById } =
  contractsHomeSlice.actions;

export default contractsHomeSlice;
